export default __webpack_public_path__ + "b37f204657aad67b03ada1ce094c0dd9.webp";